import React from "react";
import Link from "next/link";
import { BelanjaDiTokoUDJ } from "../../components/BelanjaDiToko/BelanjaDiTokoUDJ";

const Blocks = (props) => {
  const { name, items, icon, slug } = props;
  return (
    <Link href={`/${slug}`} as={`/${slug}`}>
      <a>
        <div className="commodities-blocks">
          <div className="commodities-icon">
            <img src={icon} />
          </div>
          <div className="commodities-name">{name}</div>
          <div className="commodities-items">{items}</div>
          <style jsx>{`
            .main-container {
              margin-bottom: 0px;
            }

            .commodities-blocks {
              width: 252px;
              height: 250px;
              margin-bottom: 24px;
              border-radius: 8px;
              background-color: var(--color-white);
              box-shadow: 0 4px 10px 0 rgba(64, 64, 64, 0.2);
              display: flex;
              flex-direction: column;
              padding-right: 24px;
              padding-left: 24px;
              border: solid 1px var(--color-white);
            }
            .commodities-blocks .commodities-icon {
              display: flex;
              justify-content: center;
              margin: 24px;
            }
            .commodities-blocks .commodities-name {
              font-size: 16px;
              text-align: center;
              font-weight: bold;
            }
            .commodities-blocks .commodities-items {
              font-size: 14px;
              margin: 24px;
            }
            .commodities-blocks:hover {
              cursor: pointer;
              border: solid 1px var(--color-red);
            }
            @media only screen and (max-width: 905px) {
              .commodities-blocks {
                margin: 12px;
              }
            }
            @media only screen and (max-width: 651px) {
              .commodities-blocks {
                min-width: 136px;
                max-width: 250px;
                width: 100%;
                height: auto;
                padding: 0px;
                margin: 8px;
              }
              .commodities-blocks .commodities-name {
                font-size: 12px;
                margin: 0 16px;
              }
              .commodities-blocks .commodities-items {
                font-size: 12px;
              }
              .commodities-blocks:hover {
                cursor: pointer;
                width: 198px;
                height: auto;
                border: solid 1px var(--color-red);
              }
            }
            @media only screen and (max-width: 440px) {
              .commodities-blocks {
                display: inline-block;
                background: #fff;
                margin: 0 0 1.5em;
                min-width: 260px;
                width: 100%;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                -moz-border-radius: 3px;
                -webkit-border-radius: 3px;
              }
              .commodities-blocks .commodities-icon {
                margin: 8px 0px;
                width: 100%;
              }
              .commodities-blocks .commodities-icon img {
                width: 64px;
              }
              .commodities-blocks .commodities-name {
                font-size: 12px;
              }
              .commodities-blocks .commodities-items {
                font-size: 12px;
                margin: 16px;
                text-align: center;
              }
              .commodities-blocks:hover {
                cursor: pointer;
                width: auto;
                height: auto;
                border: solid 1px var(--color-red);
              }
            }
          `}</style>
        </div>
      </a>
    </Link>
  );
};

const ShopOffline = ({ dataOfflineShop }) => {
  return (
    <>
      <div className="shop-offline-wrapper">
        <div className="shop-offline-container">
          <p>Belanja di Toko</p>
          <BelanjaDiTokoUDJ></BelanjaDiTokoUDJ>
          <div className="shop-offline-blocks-wrapper">
            <div className="shop-offline-blocks-container">
              {dataOfflineShop.map((data, key) => {
                return (
                  <Blocks
                    key={key}
                    name={data.data.name}
                    items={data.data.types}
                    icon={data.data.url}
                    slug={data.data.slug}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .shop-offline-blocks-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .shop-offline-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .shop-offline-container {
          max-width: 940px;
          width: 100%;
        }
        .shop-offline-container p {
          font-weight: bold;
          font-size: 32px;
          text-align: center;
          margin: 32px 16px 30px;
        }
        @media only screen and (max-width: 651px) {
          .shop-offline-container p {
            margin: 24px;
            font-size: 18px;
          }
          .shop-offline-blocks-container {
            width: 440px;
          }
        }
        @media only screen and (max-width: 905px) {
          .shop-offline-blocks-wrapper {
            display: flex;
            justify-content: center;
          }
          .shop-offline-blocks-container {
            width: 670px;
          }
        }
        @media only screen and (max-width: 440px) {
          .shop-offline-blocks-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 90vw;
            margin: 1.5em 0;
            padding: 0;
            -moz-column-gap: 1.5em;
            -webkit-column-gap: 1.5em;
            column-gap: 1.5em;
            font-size: 0.85em;
          }
        }
      `}</style>
    </>
  );
};

export default ShopOffline;
